<template>
    <div>
        <b-row>
            <b-col>
                <label for="venue">Sede</label>
                <app-form-select
                    id="venue"
                    :options="venues"
                    @change="loadWorkplaces"
                    value-field="id"
                    text-field="name"
                    v-model="filters.venueId"
                ></app-form-select>
            </b-col>
            <b-col>
                <label for="workplace">Puesto de trabajo</label>
                <app-form-select
                    id="workplace"
                    :options="workplaces"
                    value-field="id"
                    text-field="name"
                    v-model="filters.structureId"
                ></app-form-select>
            </b-col>
            <b-col class="mt-4" cols="auto">
                <b-btn variant="primary" @click="filter"
                    ><i class="fa fa-filter"></i
                ></b-btn>
                <b-btn variant="secondary" @click="clear"
                    ><i class="fa fa-times"></i
                ></b-btn>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    props: {
        theClient: {
            type: Object,
            require: true,
        },
    },
    data: () => ({
        venues: [],
        workplaces: [],
        filters: {
            venueId: '',
            structureId: '',
        },
    }),
    computed: {
        //
    },
    methods: {
        async loadVenues() {
            const { data } = await repo.get('venues', {
                client: this.theClient.id,
            })
            this.venues = data

            if (data.length === 1) {
                this.filters.venueId = data[0].id
                this.loadWorkplaces(data[0].id)
            }
        },
        async loadWorkplaces(venueId) {
            const { data } = await repo.get('resources/workplaces', {
                venueId,
                clientId: this.theClient.id,
            })
            this.workplaces = data
            if (data.length === 1) {
                this.filters.structureId = data[0].id
            }
        },
        filter() {
            this.$emit('filter', this.filters)
        },
        clear() {
            this.filters.venueId = ''
            this.filters.structureId = ''
            this.$emit('filter', null)
        },
    },
    created() {
        this.loadVenues()
    },
}
</script>
